$(document).on('turbolinks:load', function () {
	$('#audienceModal').on('click', 'input[id*="radio"]', function () {
    var btn_img_src = $(this).siblings().find('img.hidden').attr('src');
    var btn_text = $(this).siblings().find('.audience-item__title').text();
    $('a.only_me_link.photo img').attr('src', btn_img_src);
    $('a.only_me_link.photo img').attr('height', '30');
    $('a.only_me_link.photo img').attr('width', '30');
    $('a.only_me_link.photo span').text(btn_text);
    });
});